var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-input',{staticClass:"mt-3 w-100",attrs:{"type":_vm.field.type,"placeholder":_vm.field.title,"icon":"mode_edit","label":_vm.field.title +' *',"disabled":!_vm.edit},model:{value:(_vm.field.value),callback:function ($$v) {_vm.$set(_vm.field, "value", $$v)},expression:"field.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }